import React from 'react';
import GoogleAuth from "../GoogleAuth";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import {registerOrUpdateSupplier} from "../../api";
import {useHistory} from "react-router-dom";
import {defaultValues} from "../signupSupplier/SignupSupplierWizard";
import {AUTH_SUCCESSFUL} from "../../store/action";
import {getSupplierDataAction} from "../../store/actionCreators";
import {ADD_NOTIFICATION} from "../../store/action";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100vh',
        display: 'flex',
        paddingTop: theme.spacing(10),
        justifyContent: 'center',
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
    },
    container: {
        maxWidth: 400,
        width: '100%',
    },
    paper: {
        padding: theme.spacing(4),
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: theme.shadows[3],
    },
    title: {
        marginBottom: theme.spacing(4),
        textAlign: 'center',
        color: theme.palette.primary.main,
        fontWeight: 600,
    },
    subtitle: {
        marginBottom: theme.spacing(4),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    authContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    termsNote: {
        marginTop: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        fontSize: '0.875rem',
        maxWidth: '400px',
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    }
}));

const AuthControl = ({dispatch, getSupplierData}) => {
    const history = useHistory();
    const {t} = useTranslation();
    const classes = useStyles();

    const handleAuthFinish = async ({authToken, phone, name, email, isSignup}) => {                    
            try {
                await registerOrUpdateSupplier({...defaultValues, auth: authToken, phone, fullName: name, email, activities: []});
                dispatch({type: AUTH_SUCCESSFUL, payload: authToken});
                await getSupplierData(authToken);
                history.push("/edit-supplier");
            } catch(e) {
                dispatch({
                    type: ADD_NOTIFICATION,
                    payload: {
                        type: 'error',
                        text: t('error_registering_supplier')
                    }
                });
            }
    };

    return (
        <Box className={classes.root}>
        <Container className={classes.container}>
            <Paper className={classes.paper}>
                <Typography variant="h4" component="h1" className={classes.title}>
                    {t('app_name')}
                </Typography>
                <Typography variant="subtitle1" className={classes.subtitle}>
                    {t('sign-up-as-supplier')}
                </Typography>
                
                <Box className={classes.authContainer}>
                <GoogleAuth 
                signupMode={true}
                onFinish={handleAuthFinish}
            />
                    {/* <Divider className={classes.divider}>
                        <Typography variant="body2" className={classes.dividerText}>
                            {t('or')}
                        </Typography>
                    </Divider> */}
                    {/* <FacebookAuth 
                        title={t('login')}
                        onFinish={handleLogin}
                    /> */}
                </Box>
                <Typography className={classes.termsNote}>
                    {t('by_signing_up')}{' '}
                    <Link href="/terms" className={classes.link} target="_blank">
                        {t('terms_and_conditions')}
                    </Link>
                    {' '}{t('and')}{' '}
                    <Link href="/privacy" className={classes.link} target="_blank">
                        {t('privacy_policy')}
                    </Link>
                </Typography>
            </Paper>
        </Container>
    </Box>
    );
};

const mapDispatchToProps = dispatch => ({
    getSupplierData: getSupplierDataAction(dispatch),
    dispatch
});

export default connect(()=>({}), mapDispatchToProps)(AuthControl);